<section lvCloseOverlay withKeyboard="esc">
  <div class="photo-wrapper">
    @if (photo) {
      <img id="the-photo" [src]="photoURL" />

      @if (showTryAgainButton) {
        <button class="button is-secondary is-fullwidth" (click)="reset()">
          <span class="icon">
            <i lvIcon="refresh"></i>
          </span>
          <span translate>take-photo.component.try-again</span>
        </button>
      }

      <!--
        When the photo is already uploaded, but we are waiting for the validation response.
      -->
      @if (photoVerificationLoading()) {
        <div class="photo-validating" translate>verify-id.component.validating</div>
      }
    } @else {
      <div class="svg-wrapper">
        <lv-camera-feed
          [facing]="facing"
          [class.mirror]="true"
          [filename]="fileName"
          [keepRunning]="false"
          (capture)="capture($event)"
        ></lv-camera-feed>

        <img class="svg-item" [src]="assetSvg" />
      </div>
    }

    @if (saving) {
      <div class="photo-uploading" translate>app.uploading</div>
    }
  </div>

  <!--
    When the photo is already uploaded, and we have a validation response.
    We might need to confirm the photo or ask to retake because it's not valid.
  -->
  @if (photoVerificationResponse$ | async; as photoVerificationResponse) {
    @if (photoVerificationResponse.success) {
      @if (photoVerificationResponse.need_confirmation) {
        <div class="white">
          @if (photoType === 'id') {
            <lv-confirm-valid-id label="confirm-use-photo" (confirmed)="onPhotoConfirmed($event)"></lv-confirm-valid-id>
          }
        </div>
      }

      <div class="white submit-container">
        <button type="button" (click)="accept()" [disabled]="!photoConfirmed" class="button is-success" translate>
          take-photo.component.submit
        </button>
      </div>
    } @else {
      <div class="no-face-detected">
        <div class="message-container">
          <div class="error-title" translate>verify-id.component.failed-title</div>

          <p translate>verify-id.component.failed-content</p>
        </div>

        <div class="error-button-container">
          <button class="button" (click)="reset()">
            <span class="icon">
              <i lvIcon="refresh"></i>
            </span>
            <span translate>verify-id.component.failed-retry</span>
          </button>
        </div>
      </div>
    }
  }
</section>
